import { render, staticRenderFns } from "./paginationminNosize.vue?vue&type=template&id=427f0e64"
import script from "./paginationminNosize.vue?vue&type=script&lang=js"
export * from "./paginationminNosize.vue?vue&type=script&lang=js"
import style0 from "./paginationminNosize.vue?vue&type=style&index=0&id=427f0e64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports